import { Routes, Route } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import PrivacyPolicyPage from './Pages/HomePage/PrivacyPolicyPage';
import ScrollToTop from './components/ScrollToTop';
import FloatingContactWidget from './components/FloatingContactWidget';
import CookiePolicyPage from './Pages/HomePage/CookiePolicyPage';
import TermsOfServicePage from './Pages/HomePage/TermsOfServicePage';
import DataSecurityPage from './Pages/HomePage/DataSecurityPage';
import RiskNoticePage from './Pages/HomePage/RiskNoticePage';
import AboutUsPage from './Pages/HomePage/AboutUsPage';
import SolutionSciencePage from './Pages/HomePage/Solution/SolutionSciencePage';
import SolutionECommercePage from './Pages/HomePage/Solution/SolutionECommercePage';
import SolutionLocalPage from './Pages/HomePage/Solution/SolutionLocalPage';
import SolutionHealthPage from './Pages/HomePage/Solution/SolutionHealthPage';
import SolutionEducationPage from './Pages/HomePage/Solution/SolutionEducationPage';
import PricePage from './Pages/HomePage/PricePage';
import ChatAgentProductPage from './Pages/HomePage/Product/ChatAgentProductPage';

function App() {
  return (
    <div className="h-screen w-full bg-background">
      <ScrollToTop />
      <FloatingContactWidget />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/product/agent" element={<ChatAgentProductPage />} />
        <Route path="/price" element={<PricePage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/cookie" element={<CookiePolicyPage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
        <Route path="/data-security" element={<DataSecurityPage />} />
        <Route path="/risk-disclaimer" element={<RiskNoticePage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/solutions/science" element={<SolutionSciencePage />} />
        <Route
          path="/solutions/e-commerce"
          element={<SolutionECommercePage />}
        />
        <Route path="/solutions/local" element={<SolutionLocalPage />} />
        <Route path="/solutions/health" element={<SolutionHealthPage />} />
        <Route
          path="/solutions/education"
          element={<SolutionEducationPage />}
        />
      </Routes>
    </div>
  );
}

export default App;

